import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { ContentSectionWithIcon } from "@cinch-labs/design-system";
import { storyblokEditable } from "@cinch-nx/data-storyblok";
import { renderWithResolver } from "@cinch-nx/landing-ui-shared";
import styles from "./content-with-icon.module.css";
export var ContentWithIcon = function(blok) {
    var contentWithIcon = blok.contentWithIcon;
    return /*#__PURE__*/ _jsx("section", _object_spread_props(_object_spread({}, storyblokEditable(blok)), {
        className: styles.container,
        "data-testid": "content-with-icon",
        children: contentWithIcon.map(function(item) {
            return /*#__PURE__*/ _jsx(ContentSectionWithIcon, {
                iconName: item.iconName,
                iconGradient: "galaxy",
                title: item.title,
                children: renderWithResolver(item.body)
            }, item.title);
        })
    }));
};
